import React from 'react';
import { getFilterColumn, setFilterColumn } from '../../../../../store/utils';
import DualListBox, { DualListBoxItem } from '../../../../DualListBox';
import useStore from '../../../../Hooks/useStore';
import Input from '../../../../Input';
import * as S from '../Styles';
import SelectedItemMask from './SelectedItemMask';
import AvailableItemMask from './AvailableItemMask';

const BatchTab = () => {
  const [getters, setters] = useStore();
  const {
    user: { getSelectedFilial },
    ticket: { getTicket },
  } = getters;
  const {
    ticket: { setTicket },
    product: { findFilteredOfflineProducts, findFilteredProducts },
  } = setters;

  const searchFilter = getTicket('form.config.filters.products');

  const totalOfItems = getTicket('form.batch.total');
  const setTotalOfItems = (total: number) =>
    setTicket('form.batch.total', total);

  const type = getTicket('form.batch.productType');
  const setProductType = (type: 'normal' | 'offline') =>
    setTicket('form.batch.productType', type);

  const setSearchFilter = (filter: SearchFilter) =>
    setTicket('form.config.filters.products', filter);

  const setProductFilter = (value: string) => {
    let filter = { ...searchFilter };
    filter = setFilterColumn('ean', value, filter, 'LIKE', 'OR');
    filter = setFilterColumn('code', value, filter, 'LIKE', 'OR');
    filter = setFilterColumn('resume', value, filter, 'LIKE', 'OR');
    setSearchFilter(filter);
  };
  const productFilter = getFilterColumn('resume', searchFilter);

  const onProductListHandler = () => {
    if (type === 'offline') {
      findFilteredOfflineProducts(searchFilter).then((products) => {
        setTicket(
          'form.batch.availableProducts',
          products.data.map((product) => ({
            ...product,
            type,
            identifier: -1,
          })),
        );
        setTotalOfItems(products.meta.total);
      });
    } else if (type === 'normal') {
      findFilteredProducts(searchFilter).then((products) => {
        setTicket(
          'form.batch.availableProducts',
          products.data.map((product) => ({
            ...product,
            type,
            identifier: -1,
          })),
        );
        setTotalOfItems(products.meta.total);
      });
    }
  };

  const selectedFilial = getSelectedFilial();
  let productTimerId: NodeJS.Timeout;
  React.useEffect(() => {
    const handleInputChange = () => {
      clearTimeout(productTimerId);
      productTimerId = setTimeout(() => {
        onProductListHandler();
      }, 300);
    };
    handleInputChange();
    return () => {
      clearTimeout(productTimerId);
    };
  }, [searchFilter, selectedFilial, type]);

  const selectedProducts = getTicket('form.batch.selectedProducts');

  const availableProducts = getTicket('form.batch.availableProducts').filter(
    ({ id }) => !selectedProducts.find((item) => id === item.id),
  );

  const availableItemsList = availableProducts.map(({ ...product }) => ({
    ...product,
    type,
  }));

  const selectedItemsList = selectedProducts.map(({ ...product }) => ({
    ...product,
    type,
  }));

  const handleSelectItems = (items: DualListBoxItem[]) => {
    const newSelectedItems = [
      ...availableProducts.filter(({ id }) =>
        items.find((item) => id === item.id),
      ),
      ...selectedProducts,
    ];
    setSearchFilter(
      setFilterColumn(
        'id',
        newSelectedItems.map(({ id }) => id),
        searchFilter,
        'NOTIN',
        'AND',
      ),
    );

    setTicket('form.batch.selectedProducts', newSelectedItems);
  };

  const handleRemoveItems = (items?: DualListBoxItem[]) => {
    if (!items) {
      setSearchFilter(setFilterColumn('id', '', searchFilter, 'NOTIN', 'AND'));
      setTicket('form.batch.selectedProducts', []);
      setTicket('form.batch.pinnedProducts', []);
      return;
    }
    const newSelectedItems = [
      ...selectedProducts.filter(
        ({ id, type }) =>
          !items.find((item) => id === item.id && type === item.type),
      ),
    ];
    const newSelectedItemIds = newSelectedItems
      .filter(({ type: tp }) => tp === type)
      .map(({ id }) => id);
    setSearchFilter(
      setFilterColumn(
        'id',
        newSelectedItemIds.length > 0 ? newSelectedItemIds : '',
        searchFilter,
        'NOTIN',
        'AND',
      ),
    );
    setTicket('form.batch.selectedProducts', newSelectedItems);
    setTicket(
      'form.batch.pinnedProducts',
      getTicket('form.batch.pinnedProducts').filter(
        ({ id, type }) =>
          !items.find((item) => id === item.id && type === item.type),
      ),
    );
  };

  const getItemsPerPage = () =>
    getTicket('form.config.filters.products.limit') ?? 0;
  const getPage = () => getTicket('form.config.filters.products.page') ?? 0;

  const setPage = (page: number) => {
    setTicket('form.config.filters.products.page', page);
  };

  const setItemsPerPage = (itemsPerPage: number) => {
    setTicket('form.config.filters.products.limit', itemsPerPage);
  };

  return (
    <S.TabContainer>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '20px',
        }}
      >
        <Input
          label={'Código do Produto'}
          value={productFilter as string}
          onChange={(e) => {
            setProductFilter(e.target.value);
          }}
          errorMessage={false}
        />
        <Input.Checkbox
          style={{ margin: 0 }}
          className="form-banner-field"
          errorMessage={false}
          checked={type === 'offline'}
          onChange={(e) => {
            setProductType(e.target.checked ? 'offline' : 'normal');
          }}
          label="Preços Offline"
        />
      </div>
      <DualListBox
        availableItems={availableItemsList}
        selectedItems={selectedItemsList}
        onSelectItems={handleSelectItems}
        onRemoveItems={handleRemoveItems}
        currentPage={getPage()}
        itemsPerPage={getItemsPerPage()}
        totalOfItems={totalOfItems}
        setPage={setPage}
        setItemsPerPage={setItemsPerPage}
        AvailableItemMask={AvailableItemMask}
        SelectedItemMask={SelectedItemMask}
      />
    </S.TabContainer>
  );
};

export default BatchTab;
